export default {
    encoding: [
        {
            name: 'x',
            type: '[number | string]',
            desc: 'Specify the dataSource applied to the x-axis.',
            defaultValue: 'primary[0]',
            isRequired: 'true',
        },
        {
            name: 'y',
            type: '[number | string]',
            desc: 'Specify the dataSource applied to the y-axis.',
            defaultValue: 'primary[1]',
            isRequired: 'true',
        },
        {
            name: 'size',
            type: '[number]',
            desc: 'Specify the dataSource that is represented by the bubble size in the chart.',
            defaultValue: 'primary[2]',
            isRequired: 'true',
        },
        {
            name: 'category',
            type: '[string]',
            desc: 'Specify the dataSource that is represented by the category color schemes.',
            defaultValue: 'primary[3]',
            isRequired: 'false',
        },
    ],
    events: [],
};
